export enum UserMigrateStatus {
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  ROLLBACK = 'ROLLBACK',
}
